import { render, staticRenderFns } from "./DatetimeModern.vue?vue&type=template&id=38b3c60a&"
import script from "./DatetimeModern.vue?vue&type=script&lang=js&"
export * from "./DatetimeModern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports